/**
 * The controller's vocabulary. Buttons are named in Xbox terms (the
 * assumed baseline), actions are named in game terms, and the default
 * bindings follow Portal's console scheme: triggers fire portals (RT the
 * A-slot, LT the B-slot, bumpers as the alternate preset), A jumps, START
 * pauses. B and BACK ship unbound; X and Y carry our own respawn and
 * clear-portals since crouch and use do not exist here.
 *
 * Bindings persist in settings as JSON (action -> button indices), so
 * remapping is data, and the same layer feeds menu navigation.
 */

export const XBOX_LABELS = [
  'A', 'B', 'X', 'Y', 'LB', 'RB', 'LT', 'RT',
  'BACK', 'START', 'LS', 'RS',
  'DPAD UP', 'DPAD DOWN', 'DPAD LEFT', 'DPAD RIGHT',
];

export const PAD_ACTIONS = [
  { id: 'portalA', name: 'PORTAL A' },
  { id: 'portalB', name: 'PORTAL B' },
  { id: 'jump', name: 'JUMP' },
  { id: 'respawn', name: 'RESPAWN' },
  { id: 'clearPortals', name: 'CLEAR PORTALS' },
  { id: 'pause', name: 'PAUSE' },
];

export const DEFAULT_BINDS = {
  portalA: [7, 5],       // RT, RB
  portalB: [6, 4],       // LT, LB
  jump: [0],             // A
  respawn: [2],          // X
  clearPortals: [3],     // Y
  pause: [9],            // START
};

/** Current bindings: defaults overlaid with whatever settings persisted. */
export function loadBinds(settings) {
  const out = {};
  for (const [k, v] of Object.entries(DEFAULT_BINDS)) out[k] = [...v];
  try {
    const saved = JSON.parse(settings.get('padBinds') || '{}');
    for (const a of PAD_ACTIONS) {
      const v = saved[a.id];
      if (Array.isArray(v) && v.every((n) => Number.isInteger(n) && n >= 0 && n < 32)) {
        out[a.id] = v;
      }
    }
  } catch { /* malformed saves fall back to defaults */ }
  return out;
}

export function bindLabel(binds, actionId) {
  const v = binds[actionId] ?? [];
  return v.length ? v.map((i) => XBOX_LABELS[i] ?? `#${i}`).join(' / ') : 'UNBOUND';
}
